import { useOktaAuth } from "@okta/okta-react";
import Navbar from "../components/navbar/Navbar";
import {Container} from "@mui/material";

const BasicLayout = ({ children }) => {
  const { oktaAuth, authState } = useOktaAuth();

  return (
    <>
      {authState != null && authState.isAuthenticated ? <Navbar /> : <></>}
      <Container maxWidth= 'xl'>
        {children}
      </Container>
    </>
  );
};

export default BasicLayout;
